export class DumbLiaison {
    contactId: string;
    firstName: string;
    lastName: string;
    fullName: string;
    emailAddress: string;
    phoneNumber: string;
    phoneNumberNonDisplay: string;
    jobTitle: string;
    referredByString: string;
}
